import { render } from "./SelfAssessmentV2HeroCard.vue?vue&type=template&id=a4f8f9fe&scoped=true"
import script from "./SelfAssessmentV2HeroCard.vue?vue&type=script&lang=js"
export * from "./SelfAssessmentV2HeroCard.vue?vue&type=script&lang=js"

import "./SelfAssessmentV2HeroCard.vue?vue&type=style&index=0&id=a4f8f9fe&lang=sass&scoped=true"

import exportComponent from "../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4f8f9fe"]])

export default __exports__